export function hasOrders(orders) {
  if (!orders || orders.length === 0) {
    return false;
  }
  return true;
}
